import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedMusic from './components/FeaturedMusic';
import AboutTeaser from './components/AboutTeaser';
import MerchPreview from './components/MerchPreview';
import GalleryTeaser from './components/GalleryTeaser';

export default function Home() {
  return (
    <div className="bg-brand-dark min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedMusic />
        <AboutTeaser />
        <MerchPreview />
        <GalleryTeaser />
      </main>
      <Footer />
    </div>
  );
}
